import React, { PureComponent } from 'react';
import ReactEcharts from './ReactEcharts';

export default class Graph extends PureComponent {
  shownCatagories = {"EMData": true, "Paper": true, "Organism": true, "Author": true}

  getOption = () => {
    let {emds, papers, organisms, authors, linksEP, linksPO, linksPA} = this.props;
    const relationData = {
      "type":"force",
      "categories":[
        {"name":"EMData","keyword":{},"base":"EMData"},
        {"name":"Paper","keyword":{},"base":"Paper"},
        {"name":"Organism","keyword":{},"base":"Organism"},
        {"name":"Author","keyword":{},"base":"Author"},
      ],
      "nodes": emds.map(e => ({...e, "category":0})).concat(
        papers.map(p => ({...p, "category":1})).concat(
          organisms.map(o => ({...o, "category":2})).concat(
            authors.map(a => ({...a, "category":3}))
          )
        )
      ),
      "links": linksEP.map(link => ({
        "source":link[0], "target":link[1]+emds.length,
      })).concat(linksPO.map(link => ({
        "source":link[0]+emds.length, "target":link[1]+emds.length+papers.length,
      }))).concat(linksPA.map(link => ({
        "source":link[0]+emds.length, "target":link[1]+emds.length+papers.length+organisms.length,
      })))
    };
    return {
      color: ['#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9',
        '#bc80bd', '#ccebc5', '#8dd3c7', '#ffffbc', '#bebada', '#ffed6f'],
      legend: {
        data: ['EMData', 'Paper', 'Organism', 'Author']
      },
      series: [{
        type: 'graph',
        layout: 'force',
        animation: false,
        label: {
          normal: {
            position: 'right',
            formatter: '{b}'
          }
        },
        draggable: true,
        roam: true,
        //symbol: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
        data: relationData.nodes.map(function (node, idx) {
          node.id = idx;
          return node;
        }),
        categories: relationData.categories,
        force: {
          // initLayout: 'circular'
          // repulsion: 20,
          edgeLength: 5,
          repulsion: 20,
          gravity: 0.2
        },
        edges: relationData.links
      }]
    };
  };

  onLengendSelectChanged(params) {
    this.shownCatagories = params.selected;
  }

  onChartClick(params) {
    if(params.componentType !== 'series') {
      console.log(params);
      return;
    }
    let {emds, papers, organisms, authors} = this.props;
    let selEmds = emds.map(e => false);
    let selPapers = papers.map(p => false);
    let selOrganisms = organisms.map(o => false);
    let selAuthors = authors.map(a => false);
    if(params.data.category === 0)
      selEmds[params.dataIndex] =  true;
    else if(params.data.category === 1)
      selPapers[params.dataIndex - emds.length] =  true;
    else if(params.data.category === 2)
      selOrganisms[params.dataIndex - emds.length - papers.length] =  true;
    else if(params.data.category === 3)
      selAuthors[params.dataIndex - emds.length - papers.length - organisms.length] =  true;
    this.selectCluster(selEmds, selPapers, selOrganisms, selAuthors);
  }

  selectCluster(selEmds, selPapers, selOrganisms, selAuthors)
  {
    let {emds, papers, organisms, authors, linksEP, linksPO, linksPA} = this.props;
    let delta = 1;
    while(delta)  {
      delta = 0;
      if(this.shownCatagories.EMData && this.shownCatagories.Paper) {
        linksEP.map(link => {
          if(selEmds[link[0]] && !selPapers[link[1]]) {
            selPapers[link[1]] = true;
            ++delta;
          }
          if(!selEmds[link[0]] && selPapers[link[1]]) {
            selEmds[link[0]] = true;
            ++delta;
          }
        })
      }
      if(this.shownCatagories.Paper && this.shownCatagories.Organism) {
        linksPO.map(link => {
          if(selPapers[link[0]] && !selOrganisms[link[1]]) {
            selOrganisms[link[1]] = true;
            ++delta;
          }
          if(!selPapers[link[0]] && selOrganisms[link[1]]) {
            selPapers[link[0]] = true;
            ++delta;
          }
        })
      }
      if(this.shownCatagories.Paper && this.shownCatagories.Author) {
        linksPA.map(link => {
          if(selPapers[link[0]] && !selAuthors[link[1]]) {
            selAuthors[link[1]] = true;
            ++delta;
          }
          if(!selPapers[link[0]] && selAuthors[link[1]]) {
            selPapers[link[0]] = true;
            ++delta;
          }
        })
      }
    }
    this.props.onDrill({
      emd: emds.filter((e, index) => selEmds[index]).map(e => e.id),
      paper: papers.filter((p, index) => selPapers[index]).map(p => p.id),
      organism: organisms.filter((o, index) => selOrganisms[index]).map(o => o.id),
      author: authors.filter((a, index) => selAuthors[index]).map(a => a.id),
    });
  }

  render() {
    let onEvents = {
      'legendselectchanged': this.onLengendSelectChanged.bind(this),
      'click': this.onChartClick.bind(this),
    }
    return (
      <ReactEcharts
        option={this.getOption()}
        style={{height: `${this.props.height ? this.props.height : 700}px`, width: '100%'}}
        className='react_for_echarts'
        onEvents={onEvents}
      />
    );
  }
}
